import { Flex, Image, Text, Box, Icon } from '@chakra-ui/react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { shapeQuote, shapeTriangle, IconStar } from 'assets/icons';
import { johnMorgan } from 'assets/images';

const Testimonial: React.FC<{}> = () => {
  const { t } = useTranslation(['auth']);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
      bg="primary.500"
      overflow="hidden"
      p="8"
      position="relative"
    >
      <Image src={shapeQuote} position="absolute" left="10" top="7" />
      <Image src={shapeTriangle} position="absolute" right="0" top="7" />
      <Image src={johnMorgan} alt="John Morgan" />
      <Box maxWidth="500px" mt="5">
        <Text color="white" fontSize="xl">
          {t('auth:testimonialQuotes')}
        </Text>
        <Flex justifyContent="center" mt="6">
          <Icon as={IconStar} mr="2" />
          <Icon as={IconStar} mr="2" />
          <Icon as={IconStar} mr="2" />
          <Icon as={IconStar} mr="2" />
          <Icon as={IconStar} mr="2" />
        </Flex>
        <Text color="white" fontSize="md" textAlign="center" mt="6">
          {t('auth:shadMosley')},
          <br /> {t('auth:p&lConstruction')}
        </Text>
      </Box>
    </Flex>
  );
};

export default memo(Testimonial);
